import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { SALON, whatsappLink, telLink } from '../data/content';

const FloatingButtons = () => {
  return (
    <div className="fixed right-4 md:right-6 bottom-5 md:bottom-7 z-40 flex flex-col gap-3 items-end">
      <a
        href={telLink}
        aria-label="Call now"
        title={`Call ${SALON.phone}`}
        className="group w-14 h-14 rounded-full bg-gold hover:bg-gold-dark shadow-lg flex items-center justify-center btn-transition pulse-gold hover:scale-105"
      >
        <Phone className="w-6 h-6 text-white" />
      </a>
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Message on WhatsApp"
        title="Message on WhatsApp"
        className="group w-14 h-14 rounded-full bg-whatsapp hover:bg-whatsapp-dark shadow-lg flex items-center justify-center btn-transition pulse-green hover:scale-105"
      >
        <MessageCircle className="w-6 h-6 text-white fill-white" />
      </a>
    </div>
  );
};

export default FloatingButtons;
